module.exports = __webpack_public_path__ + "assets/lock.7819dc83.svg";